import React from "react";
import { Paper, Box } from "@mui/material";
import { Panel, Group as PanelGroup, Separator as PanelResizeHandle } from "react-resizable-panels";
import { SearchFilter } from "./panelFilter/SearchFilter";
import { TabEditNotes } from "./panelFilter/TabPanel/TabEditNotes";
import { SortFilter } from "./panelFilter/SortFilter";
import { useFilter } from "../../context/FilterContext";
import { usePanelZoom } from "../../hooks/panelFilters/usePanelZoom";
import { PanelZoomControls } from "./panelFilter/TabPanel/PanelZoomControls";

export const FilterPanel = ({ token, idDocument, nameDocument }) => {
  const { 
    notaSeleccionada, 
    setNotaSeleccionada, 
    notasSeleccionadas, 
    setNotasSeleccionadas, 
    filterState, 
    setFilterState 
  } = useFilter();

  const { zoom, zoomIn, zoomOut, resetZoom, minZoom, maxZoom } = usePanelZoom(1.0, 0.75, 1.0, 0.05);

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        height: "100%", 
        display: "flex", 
        flexDirection: "column",
        overflow: "hidden" 
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          px: 1.5,
          py: 0.5,
          borderBottom: "1px solid #f0f0f0",
 
        }}
      >
        <PanelZoomControls
          zoom={zoom}
          zoomIn={zoomIn}
          zoomOut={zoomOut}
          resetZoom={resetZoom}
          minZoom={minZoom}
          maxZoom={maxZoom}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          height: "100%",
          overflow: "hidden",
          py:0.5,
          zoom: zoom,
        }}
      >
        <PanelGroup direction="horizontal" style={{ height: "100%" }}>
          <Panel defaultSize={33} minSize={20}>
            <SearchFilter
              token={token}
              onSelectNota={setNotaSeleccionada}
              onSelectMultipleNotas={setNotasSeleccionadas}
              filterState={filterState}
              setFilterState={setFilterState}
            />
          </Panel>

          <PanelResizeHandle
            style={{
              width: "6px",
              background: "#e0e0e0",
              cursor: "col-resize",
              transition: "background 0.2s",
            }}
          />

          <Panel defaultSize={33} minSize={20}>
            <div style={{ height: "100%", overflowY: "auto" }}>
              <TabEditNotes notaSeleccionada={notaSeleccionada} />
            </div>
          </Panel>

          <PanelResizeHandle
            style={{
              width: "6px",
              background: "#e0e0e0",
              cursor: "col-resize",
              transition: "background 0.2s",
            }}
          />

          <Panel defaultSize={34} minSize={20}>
            <div style={{ height: "100%", overflowY: "auto" }}>
              <SortFilter
                token={token}
                idDocument={idDocument}
                nameDocument={nameDocument}
                notaSeleccionada={notaSeleccionada}
                notasSeleccionadas={notasSeleccionadas}
              />
            </div>
          </Panel>
        </PanelGroup>
      </Box>
    </Paper>
  );
};
